import { FC, useMemo } from 'react';
import { Alert, AlertDescription, AlertTitle, Box } from '@chakra-ui/react';
import { ParagraphInfoBoxFragment } from '../../../generated/types';
import { HTMLText } from '../../Common/HTMLText';
import slugify from '../../../utils/slugify';

interface InfoBoxProps {
  data: ParagraphInfoBoxFragment;
}

export const InfoBox: FC<InfoBoxProps> = ({ data }) => {
  if (!data.textParagraph) return null;

  return (
    <Alert
      variant={data.colorSchema}
      flexDirection="column"
      alignItems="flex-start"
      borderRadius="sm"
      py={4}
      px={6}
      border="1px solid"
      borderColor="rgba(0,0,0, .2)"
    >
      {data.textParagraph.headline && (
        <AlertTitle
          color="rgba(0,0,0, .75)"
          mb={3}
          fontSize="lg"
          id={
            data.textParagraph.addToTableOfContents
              ? slugify(data.textParagraph.headline)
              : undefined
          }
        >
          {data.textParagraph.headline}
        </AlertTitle>
      )}

      <AlertDescription color="rgba(0,0,0, .85)">
        <HTMLText text={data.textParagraph.text} />
      </AlertDescription>
    </Alert>
  );
};
